<template>
  <UModal v-model:open="openModel" :description="description" :title="title">
    <template #content>
      <div class="p-6 space-y-4">
        <slot name="content">
          <p class="text-sm text-gray-500 dark:text-gray-400">
            {{ message }}
          </p>
        </slot>
        <div class="flex flex-col-reverse sm:flex-row justify-end gap-3 pt-2">
          <UButton
            v-if="cancelLabel"
            :label="cancelLabel"
            color="neutral"
            variant="ghost"
            class="w-full sm:w-auto"
            @click="openModel = false"
          />
          <UButton
            :color="confirmColor"
            :label="confirmLabel"
            :loading="loading"
            class="w-full sm:w-auto"
            @click="$emit('confirm')"
          />
        </div>
      </div>
    </template>
  </UModal>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps({
  open: Boolean,
  title: String,
  description: String,
  message: String,
  confirmLabel: { type: String, default: 'OK' },
  cancelLabel: { type: String, default: 'Abbrechen' },
  confirmColor: { type: String, default: 'primary' },
  loading: Boolean,
})

const emit = defineEmits(['update:open', 'confirm'])

const openModel = computed({
  get: () => props.open,
  set: (value) => emit('update:open', value),
})
</script>
